import http from "@/utils/http";

export interface SearchEngineerQuery {
  project_id?: number;
  type?: number;
  keyword?: string;
  sort_field?: string;
  sort_sc?: string;
  page: number;
  page_size: number;
}

export interface IGraphQEngineerItem {
  aspect: string;
  id: number;
  is_example: number;
  project_id: number;
  team_id: number;
  title: string;
  type: number;
  version: number;
  updated_at: number;
  owner: {
    avatar: string;
    avatar_color: string;
    nickname: string;
    phone_number: string;
    uuid: string;
  };
  status?: number;
  publish_type?: number;
  use_by_session?: number;
  created_at?: number;
  shooting_theme?: number;
  video_generate_count?: number;
  actual_generated_count?: number;
  publish_platforms?: number[];
}

export const queryFields: string[] = [
  "id",
  "team_id",
  "project_id",
  "title",
  "type",
  "version",
  "aspect",
  "created_at",
  "updated_at",
  "owner { uuid phone_number avatar avatar_color nickname }",
  "is_example",
  "publish_type",
  "status",
  "video_generate_count",
  "actual_generated_count",
  "publish_platforms"
];

const generateGraphQLQuery =
  (data: SearchEngineerQuery) =>
  (fields: string[]): string => {
    const selectedFields = fields.join("\n");
    const searchParams: string[] = [];
    if (data.keyword !== undefined && data.keyword.length > 0)
      searchParams.push(`keyword: "${data.keyword}"`);
    if (data.sort_field !== undefined)
      searchParams.push(`sort_field: "${data.sort_field}"`);
    if (data.project_id !== undefined)
      searchParams.push(`project_id: ${data.project_id}`);
    if (data.page !== undefined) searchParams.push(`page: ${data.page}`);
    if (data.page_size !== undefined)
      searchParams.push(`page_size: ${data.page_size}`);
    if (data.sort_field !== undefined)
      searchParams.push(`sort_sc: "${data.sort_sc}"`);
    if (data.type !== undefined) searchParams.push(`type: ${data.type}`);
    const searchStr = searchParams.join(", ");
    return `{
        session_list (${searchStr}){
        total
        items{ ${selectedFields} }
      }
    }`;
  };

export const getEngineerList = async (
  data: SearchEngineerQuery
): Promise<{
  data: IGraphQEngineerItem[];
  total: number;
}> => {
  console.log(data, 'list-data')
  const result = await http.post(
    `/api/v1/graphql/`,
    generateGraphQLQuery(data)(queryFields).toString(),
    {
      headers: {
        "Content-Type": "application/graphql",
      },
    }
  );
  console.log(result);
  return {
    data: result?.data?.session_list?.items || [],
    total: result?.data?.session_list?.total || 0,
  };
};
